// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"831b91b1","142":"1961f97a","309":"176b3cbb","442":"38fa67d0","453":"7feb3dc8","511":"b7a4feed","590":"c98c5cbd","624":"25240f73","683":"e64f7c73","778":"a4b9e0ba","886":"50717278","896":"acd3a790","929":"0ca150a1","939":"32bac5e9"}[chunkId] + ".chunk.js";
};